import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonIconType, ButtonType } from '../../../enum/common-enum';
import { TooltipDirective } from '../../../directives/tooltip.directive';

type ButtonIconPosition = 'left' | 'right';

@Component({
  selector: 'careposi-text-button',
  templateUrl: './text-button.component.html',
  styleUrls: ['./text-button.component.scss'],
  imports: [CommonModule, TooltipDirective],
  standalone: true,
})
export class TextButtonComponent implements OnInit {
  @Input() iconType: ButtonIconType | undefined;
  @Input() buttonText: string = "";
  @Input() buttonType: ButtonType = ButtonType.PRIMARY;
  @Input() disabled: boolean = false;
  @Input() buttonStyle: any = {};
  @Input() imgUrl: any = null;
  @Input() iconPosition: ButtonIconPosition = 'left';
  @Input() tooltipEnabled: boolean = false;
  @Output() btnClick = new EventEmitter();
  @Output() btnMouseOver = new EventEmitter();
  @Output() btnMouseOut = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }
  clickHandler() {
    this.btnClick.emit();
  }

  onMouseOver() {
    this.btnMouseOver.emit();
  }

  onMouseOut() {
    this.btnMouseOut.emit();
  }

}
